import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../../Components/Common/Loader";
import SystemModal from "../../Components/Common/SystemModal";
import ajaxCard from "../../util/remote/ajaxCard";


const RegisterCard=(props)=>{

  const [cardNumber, setCardNumber] = useState("");
  const [cardType, setCardType] = useState("");

  const [loading, setLoading] = useState(false)


  const data = {
    card_number: cardNumber,
    type: cardType
  };

  const handleAdd = async (e) => {
    e.preventDefault();

    if (cardNumber.length > 0 || cardType.length > 0) {
      setLoading(true)
      const server_response = await ajaxCard.createCard(data);
      setLoading(false)
      if (server_response.status === "OK") {
        toast.success(server_response.message);
        props.countAllCards()
        props.getAllCards(props.page)
        props.getUnassignedCards(props.unassignedPage)

        resetForm();
      } else {
        toast.error(server_response.message);
      }
    } else {
      toast.error("Complete all fields and try again");
    }
  };

  const resetForm = () => {
    setCardNumber("");
  };
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleAdd}>Register Card<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Register New Card"
            id="model-card-register"
            size="md"
            footer={RenderFooter}
        >

      <div className="row">
        <div className="col-xl-12 col-lg-12 col-12 form-group">
          <label htmlFor="">Card Number <span style={{color:"red"}}>*</span></label>
          <input type="text" value={cardNumber} style={{border: "1px solid grey"}} placeholder="Enter name of card number.." onChange={(e)=>setCardNumber(e.target.value)} className="form-control"/>
        </div>
        <div className="col-xl-12 col-lg-12 col-12 form-group">
          <label htmlFor="">Type <span style={{color:"red"}}>*</span></label>
          <select
                    style={{border: "1px solid grey"}}
                    className="col-12 form-control"
                    value={cardType}
                    onChange={(e) => setCardType(e.target.value)}>
                    <option value="" selected disabled>Select card type..</option>
                    <option value="CARD">Card</option>
                    <option value="WRISTBAND">Wristband</option>

                </select>
        </div>
      </div>
       
        </SystemModal>
    )
}

export default RegisterCard

